import { Controller } from "@hotwired/stimulus";

// Generic add/remove controller for accepts_nested_attributes_for forms.
// Used on the Public Website admin to manage an unbounded list of
// testimonials. Two responsibilities:
//
//   1. Clone a hidden <template data-target="nested-fields.template"> when
//      the user clicks the "add" button. Each clone gets a fresh
//      timestamp-based index so Rails treats it as a new record.
//
//   2. On remove, hide the row and inject a `[_destroy]=1` field so the
//      backend tears the persisted row down. New (unsaved) rows are just
//      removed from the DOM since they have no DB row to destroy.
export default class extends Controller {
  static targets = ["template", "container", "row"];

  add(event) {
    event.preventDefault();
    const html = this.templateTarget.innerHTML.replaceAll(/__INDEX__/g, this.nextIndex());
    this.containerTarget.insertAdjacentHTML("beforeend", html);
  }

  remove(event) {
    event.preventDefault();
    const row = event.currentTarget.closest("[data-nested-fields-target='row']");
    if (!row) return;

    const idField = row.querySelector("input[name$='[id]']");
    if (idField && idField.value) {
      // Persisted row — hide it and post a _destroy flag.
      row.style.display = "none";
      const destroyField = row.querySelector("input[name$='[_destroy]']");
      if (destroyField) {
        destroyField.value = "1";
      } else {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = idField.name.replace(/\[id\]$/, "[_destroy]");
        input.value = "1";
        row.appendChild(input);
      }
    } else {
      // Brand-new row — just yank it.
      row.remove();
    }
  }

  // Monotonically increasing index. Timestamp keeps it unique even across
  // rapid clicks; Rails only cares that distinct index values arrive, so
  // we don't need to scan the existing rows.
  nextIndex() {
    return new Date().getTime() + Math.floor(Math.random() * 1000);
  }
}
